import { compact, isEqual, lowerCase, sortBy, startCase, without } from 'lodash';
import React, { useState } from 'react';
import firebase from "firebase/app";

interface IProps {
    user: firebase.User;
}

export function UserUpdates({ user }: IProps) {
    const [emailsInput, setEmailsInput] = useState("");
    const [groupsToRemoveInput, setGroupsToRemoveInput] = useState("");
    const [groupsToAddInput, setGroupsToAddInput] = useState("");
    const [rolesToAddInput, setRolesInput] = useState("");
    const [info, setInfo] = useState("");

    const handleSubmit = async (event: React.MouseEvent) => {
        event.preventDefault();
        setInfo("");
        const backendUrl = process.env.REACT_APP_CLOUD_FUNCTIONS_ENDPOINT_URL;
        const emails = compact(
            emailsInput.split(",").map((email) => email.trim().toLowerCase())
        );
        const groupsToRemove = compact(groupsToRemoveInput.split(",").map((group) => group.trim()));
        const groupsToAdd = compact(groupsToAddInput.split(",").map((group) => group.trim()));
        const rolesToAdd = compact(rolesToAddInput.split(",").map(lowerCase).map(startCase));

        const idToken = await user.getIdToken();

        const response = await fetch(`${backendUrl}/createOrUpdateUsersByEmail`, {
            method: "post",
            headers: {
                Authorization: `idToken ${idToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                emails,
                rolesToAdd,
                groupsToAdd,
                groupsToRemove,
            }),
        });

        if (response.ok) {
            const result = await response.json();
            const usersData: { email: string;[key: string]: any }[] | undefined =
                result.usersData;
            const returnedEmails = Array.isArray(usersData)
                ? usersData.map((user) => user.email)
                : [];
            const allEmailWhitelisted = isEqual(
                sortBy(returnedEmails),
                sortBy(emails)
            );

            //TODO: Put all the console stuff at the bottom of the page as well
            if (allEmailWhitelisted) {
                alert(
                    "All emails added succesfully. Check console to see added/modified userData"
                );
                console.log(result);
                setInfo(`Added emails: ${JSON.stringify(returnedEmails)}`);
            } else {
                alert(
                    "Partial success. Some users have been succesfully whitelisted, but some might have been skipped. Check console for the list."
                );
                console.log(
                    "UserData returned by createOrUpdateUsersByEmail endpoint",
                    result
                );
                console.log(
                    "Emails that might have been skipped:",
                    without(emails, ...returnedEmails)
                );
                setInfo(
                    `Emails that might have been skipped ${JSON.stringify(
                        without(emails, ...returnedEmails)
                    )}`
                );
            }
        } else {
            alert(
                `Oops something went wrong endpoint returned status ${response.status}`
            );
        }
    };
    return <div style={{ fontSize: 14 }}>
        <h4>User updates</h4>
        <p>
            This is used for updating roles or groups for specific users. Groups determine which features that a user has access too.
        </p>
        <p>
            This is includes a "free access" feature that circumvents the paywall. Groups that get free access are "Collaborators" and "ClinicMembers".
        </p>
        <div>
            Emails to add or update (split by comma) <br />
            <textarea
                value={emailsInput}
                style={{ width: '100%' }}
                onChange={(event) => setEmailsInput(event.target.value)}
                rows={2}
                cols={40}
                id="emails"
                placeholder="someEmail@email.com, someOtherEmail@otherEmail.com"
            ></textarea>
            <br />
            <p>
                Role to add
                <br />
                <select
                    name="role"
                    id="role-input"
                    style={{ width: '100%' }}
                    onChange={(event) => {
                        setRolesInput(event.target.value);
                        console.log(event);
                    }}
                >
                    <option value=""></option>
                    <option value="Therapist">Therapist</option>
                    <option value="Admin">Admin</option>
                    <option value="Wavepaths Guide">Guide</option>
                    <option value="Composer">Composer</option>
                </select>
                <br />
            </p>
            <p>
                Groups/cohorts to <strong>add</strong> (split by comma)
                <br />
                <input
                    value={groupsToAddInput}
                    onChange={(event) => setGroupsToAddInput(event.target.value)}
                    style={{ width: '100%' }}
                    id="groups-to-add"
                    placeholder="Collaborators, ClinicMembers, b2bBetaTesters" />
            </p>
            <p>
                Groups/cohorts to <strong>remove</strong>  (split by comma)
                <br />
                <input
                    value={groupsToRemoveInput}
                    onChange={(event) => setGroupsToRemoveInput(event.target.value)}
                    style={{ width: '100%' }}
                    id="groups-to-remove"
                    placeholder="Collaborators, ClinicMembers, b2bBetaTesters" />
            </p>
            <button onClick={handleSubmit}>Submit</button>
        </div><p>{info}</p></div>
}